var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var http = require('http');

var https = require('https');

var urlUtil = require('url');

module.exports.default = function (options) {
  if (options.fetcher) {
    return options.fetcher(options.uri);
  }

  return new Promise(function (resolve, reject) {
    var _urlUtil$parse = urlUtil.parse(options.uri),
        hostname = _urlUtil$parse.hostname,
        path = _urlUtil$parse.path,
        port = _urlUtil$parse.port,
        protocol = _urlUtil$parse.protocol;

    var requestOptions = _objectSpread({
      hostname: hostname,
      path: path,
      port: port,
      method: 'GET'
    }, options.headers && {
      headers: _objectSpread({}, options.headers)
    }, {}, options.timeout && {
      timeout: options.timeout
    }, {}, options.agent && {
      agent: options.agent
    });

    var httpRequestLib = protocol === 'https:' ? https : http;
    httpRequestLib.request(requestOptions, function (res) {
      var rawData = '';
      res.setEncoding('utf8');
      res.on('data', function (chunk) {
        rawData += chunk;
      });
      res.on('end', function () {
        if (res.statusCode < 200 || res.statusCode >= 300) {
          var errorMsg = res.body && (res.body.message || res.body) || res.statusMessage || "Http Error ".concat(res.statusCode);
          reject({
            errorMsg: errorMsg
          });
        } else {
          try {
            resolve(rawData && JSON.parse(rawData));
          } catch (error) {
            reject(error);
          }
        }
      });
    }).on('error', function (e) {
      return reject(e);
    }).end();
  });
};